/*!
 * tshirt.ge — Size Finder v1
 * 3 steps: height/weight → body shape → preferred fit → recommended size.
 * No dependencies. Saves the shopper's answers in localStorage only.
 */
(function (w, d) {
  'use strict';

  var STORE_KEY = 'sf-profile-v1';

  /* ---------- copy ---------- */
  var T = {
    ka: {
      open: 'გამოთვალე შენი ზომა',
      openSaved: 'შენი ზომა: {s}',
      eyebrow: 'ზომის დამდგენი',
      step: '{n} / 3',
      s1Title: 'მოდი, შენი ზომა გამოვთვალოთ',
      s1Sub: 'საკმარისია ორი რამ: სიმაღლე და წონა. რიცხვზე გადაათრიე ან დააჭირე − / +.',
      female: 'ქალი', male: 'კაცი',
      height: 'სიმაღლე', weight: 'წონა',
      cm: 'სმ', kg: 'კგ', lb: 'lb',
      unitsMetric: 'სმ / კგ', unitsImperial: 'ft / lb',
      live: 'წინასწარი შეფასება',
      liveSub: 'შემდეგ ნაბიჯებში დაზუსტდება',
      s2Title: 'სხეულის ფორმა',
      s2Sub: 'ტანსაცმელი სხეულს ერგება და არა მხოლოდ ციფრებს. თუ არ ხარ დარწმუნებული, დატოვე საშუალო.',
      chest: 'მკერდი', stomach: 'მუცელი', hips: 'თეძოები',
      chestO: ['ვიწრო', 'საშუალო', 'განიერი'],
      stomachO: ['ბრტყელი', 'საშუალო', 'მრგვალი'],
      hipsO: ['ვიწრო', 'საშუალო', 'განიერი'],
      s3Title: 'როგორ გიყვარს, რომ გეცვას?',
      s3Sub: 'ზომას შენს სტილზე მოვარგებთ.',
      fit: {
        slim: ['მჭიდრო', 'სხეულს მიჰყვება. სუფთა, მოწესრიგებული სილუეტი.'],
        regular: ['სტანდარტული', 'ისე ზის, როგორც მოდელია ჩაფიქრებული.'],
        relaxed: ['თავისუფალი', 'მეტი სივრცე მოძრაობისთვის და ქვემოთ ჩასაცმელისთვის.']
      },
      best: 'საუკეთესო ზომა',
      viewing: 'ზომა {s}',
      match: '{n}% დამთხვევა',
      tapHint: 'დააჭირე სხვა ზომას და ნახე, როგორ მოგერგება.',
      length: 'სიგრძე', sleeve: 'მკლავი',
      scaleChest: ['მჭიდრო', 'იდეალური', 'თავისუფალი'],
      scaleLen: ['მოკლე', 'იდეალური', 'გრძელი'],
      noteLabel: 'შენიშვნა',
      notePerfect: 'შენი მონაცემებით ეს ზომა ზუსტად მოგერგება.',
      noteBigger: 'ორ ზომას შორის ხარ. თუ უფრო თავისუფალი გიყვარს, აირჩიე {s}.',
      noteSmaller: 'ორ ზომას შორის ხარ. თუ უფრო მჭიდრო გიყვარს, აირჩიე {s}.',
      noteTooSmall: 'ამ მოდელის ყველაზე დიდი ზომაც შეიძლება მკერდში მჭიდრო იყოს.',
      noteTooBig: 'ამ მოდელის ყველაზე პატარა ზომაც შეიძლება ცოტა თავისუფალი იყოს.',
      noteTight: '{s} მკერდში შენთვის მჭიდრო იქნება. რეკომენდებულია {b}.',
      noteLoose: '{s} შენთვის თავისუფლად ჩამოიკიდება. რეკომენდებულია {b}.',
      noteOther: '{s} ასევე მოგერგება, ოღონდ {b} უკეთესია.',
      next: 'შემდეგი', back: 'უკან', show: 'ზომის ნახვა',
      choose: 'ავირჩიოთ {s}', chosen: 'ზომა {s} არჩეულია',
      edit: 'პასუხების შეცვლა', close: 'დახურვა',
      table: 'ზომების ცხრილი (სმ)',
      tableNote: 'მკერდი იზომება ერთი იღლიიდან მეორემდე, ტანსაცმლის ბრტყლად დადებულ მდგომარეობაში.',
      privacy: 'შენი პასუხები მხოლოდ ამ მოწყობილობაზე ინახება.',
      drag: 'გადაათრიე'
    },
    en: {
      open: 'Calculate your size',
      openSaved: 'Your size: {s}',
      eyebrow: 'Size finder',
      step: '{n} / 3',
      s1Title: "Let's find your fit",
      s1Sub: 'Two measurements are all it takes. Drag a number or tap − / +.',
      female: 'Female', male: 'Male',
      height: 'Height', weight: 'Weight',
      cm: 'cm', kg: 'kg', lb: 'lb',
      unitsMetric: 'cm / kg', unitsImperial: 'ft / lb',
      live: 'Live estimate',
      liveSub: 'Refined in the next steps',
      s2Title: 'Your shape',
      s2Sub: 'Clothes fit bodies, not numbers. Not sure? Leave it at average.',
      chest: 'Chest', stomach: 'Stomach', hips: 'Hips',
      chestO: ['Slimmer', 'Average', 'Broader'],
      stomachO: ['Flatter', 'Average', 'Rounder'],
      hipsO: ['Narrower', 'Average', 'Wider'],
      s3Title: 'How do you like it to fit?',
      s3Sub: "We'll size around the way you wear it.",
      fit: {
        slim: ['Slim', 'Follows the body. Sharp and tailored.'],
        regular: ['Regular', 'The silhouette the design intended.'],
        relaxed: ['Relaxed', 'Room to move and to layer underneath.']
      },
      best: 'Best match',
      viewing: 'Size {s}',
      match: '{n}% fit match',
      tapHint: 'Tap a size to see how it would fit.',
      length: 'Length', sleeve: 'Sleeve',
      scaleChest: ['Snug', 'Ideal', 'Roomy'],
      scaleLen: ['Short', 'Ideal', 'Long'],
      noteLabel: 'Fit note',
      notePerfect: 'Against your measurements this size fits true.',
      noteBigger: "You're between sizes. Prefer more room? Go for {s}.",
      noteSmaller: "You're between sizes. Prefer it closer? Go for {s}.",
      noteTooSmall: 'Even the largest size of this style may feel snug across the chest.',
      noteTooBig: 'Even the smallest size of this style may fit a little loose.',
      noteTight: '{s} would be tight across the chest. We recommend {b}.',
      noteLoose: '{s} would hang loose on you. We recommend {b}.',
      noteOther: '{s} would also work, but {b} fits better.',
      next: 'Continue', back: 'Back', show: 'Find my size',
      choose: 'Select {s}', chosen: 'Size {s} selected',
      edit: 'Edit answers', close: 'Close',
      table: 'Size chart (cm)',
      tableNote: 'Chest is measured armpit to armpit with the garment laid flat.',
      privacy: 'Your answers are saved only on this device.',
      drag: 'drag'
    }
  };

  /* Fit model per garment kind.
     ease = how much bigger the garment circumference is than the body (cm).
     len / sleeve = target garment length as a share of the shopper's height. */
  var KIND = {
    tee:    { slim: 7,  regular: 12, relaxed: 19, len: 0.405, sleeve: 0.12 },
    hoodie: { slim: 12, regular: 17, relaxed: 24, len: 0.38,  sleeve: 0.30 }
  };

  /* ---------- helpers ---------- */
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function fmt(s, o) { return String(s).replace(/\{(\w+)\}/g, function (_, k) { return o[k]; }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function load() { try { return JSON.parse(w.localStorage.getItem(STORE_KEY)) || null; } catch (e) { return null; } }
  function save(p) { try { w.localStorage.setItem(STORE_KEY, JSON.stringify(p)); } catch (e) {} }

  /* ---------- body estimate (cm) ---------- */
  function bodyEstimate(p) {
    var m = p.sex === 'm';
    var chest = m ? 0.6 * p.w + 0.22 * p.h + 12 : 0.55 * p.w + 0.2 * p.h + 22;
    var waist = m ? 0.9 * p.w + 0.1 * p.h - 4 : 0.8 * p.w + 0.15 * p.h - 1;
    var hips  = m ? 0.6 * p.w + 0.3 * p.h + 1 : 0.7 * p.w + 0.35 * p.h;
    chest += [-3, 0, 4][p.chest + 1];
    waist += [-3, 0, 6][p.stomach + 1];
    hips  += [-3, 0, 5][p.hips + 1];
    return { chest: chest, waist: waist, hips: hips };
  }

  function recommend(p, chart) {
    var k = KIND[chart.kind] || KIND.tee;
    var b = bodyEstimate(p);
    var eff = Math.max(b.chest, b.waist + 2, b.hips * 0.88); // straight-cut garment: widest point wins
    var tgt = k[p.fit] || k.regular;
    var lenT = p.h * k.len + (p.fit === 'relaxed' ? 1.5 : 0) + (p.sex === 'f' ? -1.5 : 0);
    var slT = p.h * k.sleeve;
    var rows = chart.sizes.map(function (s, i) {
      var ease = chart.chest[i] * 2 - eff;
      var dc = ease - tgt;
      // chest: free zone −2…+4 cm around the target ease, tight is punished harder than loose
      var pc = dc < -2 ? Math.pow((dc + 2) / 3, 2) * 1.4 : dc > 4 ? Math.pow((dc - 4) / 5, 2) : 0;
      pc += Math.pow(dc / 10, 2) * 0.3; // tie-break towards the target
      if (ease < 2) pc += 6;
      var dl = chart.length[i] - lenT;
      var ds = chart.sleeve ? chart.sleeve[i] - slT : 0;
      var pl = Math.abs(dl) > 3 ? Math.pow((Math.abs(dl) - 3) / 4, 2) * (dl < 0 ? 0.75 : 0.5) : 0;
      var ps = Math.abs(ds) > 3 ? Math.pow((Math.abs(ds) - 3) / 4, 2) * (chart.kind === 'hoodie' ? 0.3 : 0.15) : 0;
      var P = pc + pl + ps;
      return {
        size: s, i: i, P: P,
        match: clamp(Math.round(98 * Math.exp(-P / 4)), 40, 98),
        dev: { chest: dc, length: dl, sleeve: ds }
      };
    });
    var sorted = rows.slice().sort(function (a, c) { return a.P - c.P; });
    return { rows: rows, best: sorted[0], second: sorted[1] };
  }

  function noteFor(t, rec, view) {
    var best = rec.best, n = rec.rows.length;
    if (view && view.i !== best.i) {
      if (view.dev.chest < -3) return fmt(t.noteTight, { s: view.size, b: best.size });
      if (view.dev.chest > 6) return fmt(t.noteLoose, { s: view.size, b: best.size });
      return fmt(t.noteOther, { s: view.size, b: best.size });
    }
    if (best.i === n - 1 && best.dev.chest < -2) return t.noteTooSmall;
    if (best.i === 0 && best.dev.chest > 5) return t.noteTooBig;
    var s2 = rec.second;
    if (s2 && Math.abs(s2.i - best.i) === 1 && s2.P - best.P < 0.35) {
      return fmt(s2.i > best.i ? t.noteBigger : t.noteSmaller, { s: s2.size });
    }
    return t.notePerfect;
  }

  /* ---------- drawings ---------- */
  function figure(h, wt, sex) {
    var bmi = wt / Math.pow(h / 100, 2), f = clamp((bmi - 17) / 22, 0, 1), m = sex === 'm';
    var s = (h / 200), top = 168 - 160 * s, cx = 50;
    function y(v) { return (top + v * s).toFixed(1); }
    function x(v) { return (cx + v * s).toFixed(1); }
    var sh = (m ? 16 : 13) + f * 8, wa = (m ? 11.5 : 9.5) + f * 13, hp = (m ? 12.5 : 14.5) + f * 10;
    var arm = (5 + f * 3.5) * s, leg = (7 + f * 6) * s;
    return '<svg viewBox="0 0 100 170" aria-hidden="true" class="sf-fig">' +
      '<circle cx="50" cy="' + y(11) + '" r="' + (8.5 * s).toFixed(1) + '"/>' +
      '<path d="M' + x(-3.5) + ' ' + y(18) + 'H' + x(3.5) + 'V' + y(25) + 'H' + x(-3.5) + 'Z"/>' +
      '<path d="M' + x(-sh) + ' ' + y(25) + 'H' + x(sh) + 'L' + x(wa) + ' ' + y(64) + 'L' + x(hp) + ' ' + y(84) +
        'H' + x(-hp) + 'L' + x(-wa) + ' ' + y(64) + 'Z"/>' +
      '<line x1="' + x(-sh - 1) + '" y1="' + y(29) + '" x2="' + x(-sh - 4 - f * 3) + '" y2="' + y(86) + '" stroke-width="' + arm.toFixed(1) + '"/>' +
      '<line x1="' + x(sh + 1) + '" y1="' + y(29) + '" x2="' + x(sh + 4 + f * 3) + '" y2="' + y(86) + '" stroke-width="' + arm.toFixed(1) + '"/>' +
      '<line x1="' + x(-hp * 0.5) + '" y1="' + y(82) + '" x2="' + x(-hp * 0.42) + '" y2="' + y(157) + '" stroke-width="' + leg.toFixed(1) + '"/>' +
      '<line x1="' + x(hp * 0.5) + '" y1="' + y(82) + '" x2="' + x(hp * 0.42) + '" y2="' + y(157) + '" stroke-width="' + leg.toFixed(1) + '"/>' +
      '</svg>';
  }

  function shapeIcon(type, v) {
    var p;
    if (type === 'chest') {
      var t = 15 + v * 4, b = 10 + v * 1;
      p = 'M' + (24 - t) + ' 6H' + (24 + t) + 'L' + (24 + b) + ' 42H' + (24 - b) + 'Z';
    } else if (type === 'stomach') {
      var bulge = 6 + v * 5;
      p = 'M16 4C22 10 20 16 20 22C' + (20 + bulge) + ' 26 ' + (20 + bulge) + ' 36 18 44';
      return '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="' + p + '" fill="none" stroke-width="2.2" stroke-linecap="round"/>' +
        '<path d="M32 4V44" fill="none" stroke-width="1" stroke-dasharray="2 3" opacity=".45"/></svg>';
    } else {
      var hw = 11 + v * 5;
      p = 'M14 4C14 14 18 18 18 22C18 26 ' + (24 - hw) + ' 32 ' + (24 - hw) + ' 44M34 4C34 14 30 18 30 22C30 26 ' + (24 + hw) + ' 32 ' + (24 + hw) + ' 44';
      return '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="' + p + '" fill="none" stroke-width="2.2" stroke-linecap="round"/></svg>';
    }
    return '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="' + p + '" fill="none" stroke-width="2.2" stroke-linejoin="round"/></svg>';
  }

  function fitIcon(fit) {
    var wv = { slim: 9, regular: 12, relaxed: 16 }[fit];
    return '<svg viewBox="0 0 40 40" aria-hidden="true"><path d="M' + (20 - wv - 5) + ' 9L' + (20 - wv) + ' 6H15C16 9 24 9 25 6H' + (20 + wv) +
      'L' + (20 + wv + 5) + ' 9L' + (20 + wv + 3) + ' 15L' + (20 + wv) + ' 14V34H' + (20 - wv) + 'V14L' + (20 - wv - 3) + ' 15Z"/></svg>';
  }

  /* ---------- size table from the theme's "Size guide" block ----------
     Accepts rows = sizes ("ზომა | მკერდი | სიგრძე | მკლავი" then "S | 51 | 69 | 19")
     or rows = measurements ("ზომა | S | M | L" then "მკერდი | 51 | 54 | 56"). */
  var COL = { chest: /მკერდ|სიგან|chest|width|pit/i, length: /სიგრძ|length/i, sleeve: /მკლავ|sleeve/i };
  function colOf(s) { for (var k in COL) if (COL[k].test(s || '')) return k; return null; }
  function num(v) { return parseFloat(String(v).replace(',', '.')); }
  function parseTable(txt) {
    var rows = String(txt || '').split(/\r?\n/).map(function (r) { return r.split('|').map(function (c) { return c.trim(); }); })
      .filter(function (r) { return r.length > 1 && r.join('') !== ''; });
    if (rows.length < 2) return null;
    var head = rows[0], body = rows.slice(1), out = { sizes: [] };
    if (body.some(function (r) { return colOf(r[0]); })) {
      out.sizes = head.slice(1);
      body.forEach(function (r) { var k = colOf(r[0]); if (k) out[k] = r.slice(1).map(num); });
    } else {
      var cols = head.map(colOf);
      body.forEach(function (r) {
        out.sizes.push(r[0]);
        cols.forEach(function (k, i) { if (k && i > 0) (out[k] = out[k] || []).push(num(r[i])); });
      });
    }
    var n = out.sizes.length;
    function ok(a) { return a && a.length === n && !a.some(isNaN); }
    if (!n || !ok(out.chest) || !ok(out.length)) return null;
    if (!ok(out.sleeve)) delete out.sleeve;
    return out;
  }
  /* keep only the sizes this product is actually sold in */
  function limitSizes(c, onProduct) {
    if (!onProduct || !onProduct.length) return c;
    var want = onProduct.map(function (s) { return String(s).trim().toUpperCase(); });
    var idx = []; c.sizes.forEach(function (s, i) { if (want.indexOf(String(s).trim().toUpperCase()) > -1) idx.push(i); });
    if (idx.length < 2) return c;
    var out = Object.assign({}, c);
    ['sizes', 'chest', 'length', 'sleeve'].forEach(function (k) { if (c[k]) out[k] = idx.map(function (i) { return c[k][i]; }); });
    return out;
  }
  var KIND_NAME = { ka: { tee: 'მაისური', hoodie: 'ჰუდი' }, en: { tee: 'T-shirt', hoodie: 'Hoodie' } };

  /* site language: Shopify locale, or the GEO/ENG pill (Google Translate cookie) */
  function siteLang(fallback) {
    var m = d.cookie.match(/(?:^|; )googtrans=([^;]*)/);
    if (m) { var v = decodeURIComponent(m[1]).split('/').pop(); if (v) return v; }
    return fallback || 'ka';
  }

  /* ---------- page integration: pick the size on the product form ---------- */
  function selectSizeOnPage(size) {
    var up = String(size).trim().toUpperCase();
    // tshirt.ge theme: size pills / variant cards carry data-option-value
    var main = d.querySelector('[data-main-product]');
    if (main) {
      var opts = main.querySelectorAll('.pdp__option--size [data-option-value], [data-option-index] [data-option-value]');
      for (var q = 0; q < opts.length; q++) {
        if (String(opts[q].getAttribute('data-option-value')).trim().toUpperCase() === up) { opts[q].click(); return true; }
      }
    }
    var form = d.querySelector('form[action*="/cart/add"]');
    var scope = (form && (form.closest('[data-section-type], section, .product, main'))) || d;
    var i, el;
    var radios = scope.querySelectorAll('input[type="radio"]');
    for (i = 0; i < radios.length; i++) {
      el = radios[i];
      if (el.value.trim().toUpperCase() === up) {
        var lbl = el.id && scope.querySelector('label[for="' + (w.CSS && CSS.escape ? CSS.escape(el.id) : el.id) + '"]');
        (lbl || el).click();
        if (!el.checked) { el.checked = true; el.dispatchEvent(new Event('change', { bubbles: true })); }
        return true;
      }
    }
    var sels = scope.querySelectorAll('select');
    for (i = 0; i < sels.length; i++) {
      for (var j = 0; j < sels[i].options.length; j++) {
        if (sels[i].options[j].value.trim().toUpperCase() === up) {
          sels[i].value = sels[i].options[j].value;
          sels[i].dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }
    var sw = scope.querySelectorAll('[data-value]');
    for (i = 0; i < sw.length; i++) {
      if (String(sw[i].getAttribute('data-value')).trim().toUpperCase() === up) { sw[i].click(); return true; }
    }
    return false;
  }

  /* ---------- component ---------- */
  function SizeFinder(opts) {
    this.o = opts;
    this.lang = String(opts.lang || 'ka').slice(0, 2) === 'en' ? 'en' : 'ka';
    this.chart = opts.charts[opts.chartKey];
    var saved = load();
    this.p = Object.assign({ sex: 'm', h: 178, w: 78, chest: 0, stomach: 0, hips: 0, fit: 'regular', imperial: false }, saved || {});
    this.step = saved && saved.done ? 4 : 1;
    this.view = null;
    this.build();
  }

  SizeFinder.prototype.t = function () { return T[this.lang]; };

  SizeFinder.prototype.build = function () {
    var self = this, o = this.o;
    var root = d.createElement('div');
    root.className = 'sf notranslate' + (o.mode === 'inline' ? ' sf--inline' : '');
    root.setAttribute('translate', 'no');
    if (o.mode === 'inline') {
      root.innerHTML = '<div class="sf-dialog" aria-live="polite"></div>';
      o.container.appendChild(root);
    } else {
      root.innerHTML = '<div class="sf-overlay" hidden><div class="sf-dialog" role="dialog" aria-modal="true" tabindex="-1"></div></div>';
      d.body.appendChild(root);
      this.overlay = root.querySelector('.sf-overlay');
      this.overlay.addEventListener('click', function (e) { if (e.target === self.overlay) self.close(); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !self.overlay.hidden) self.close(); });
    }
    this.root = root;
    this.dlg = root.querySelector('.sf-dialog');
    this.dlg.addEventListener('click', function (e) { self.onClick(e); });
    this.dlg.addEventListener('keydown', function (e) { self.onKey(e); });
    this.dlg.addEventListener('pointerdown', function (e) { self.onDragStart(e); });
    if (o.trigger) {
      o.trigger.addEventListener('click', function () { self.open(); });
      this.updateTrigger();
    }
    this.render();
  };

  SizeFinder.prototype.updateTrigger = function () {
    var tr = this.o.trigger; if (!tr) return;
    var t = this.t(), label = tr.querySelector('[data-sf-label]') || tr;
    if (this.p.done) label.textContent = fmt(t.openSaved, { s: recommend(this.p, this.chart).best.size });
    else label.textContent = (this.lang === 'ka' && this.o.labelKa) || t.open;
  };

  SizeFinder.prototype.reload = function (profile) {
    var s = profile ? JSON.parse(JSON.stringify(profile)) : load();
    if (s) { Object.assign(this.p, s); if (s.done) { this.step = 4; this.view = null; } }
    this.updateTrigger();
  };

  SizeFinder.prototype.open = function () {
    if (!this.overlay) return;
    this.reload();
    this.lastFocus = d.activeElement;
    this.overlay.hidden = false;
    d.documentElement.classList.add('sf-lock');
    this.render();
    this.dlg.focus();
  };
  SizeFinder.prototype.close = function () {
    if (!this.overlay) return;
    this.overlay.hidden = true;
    d.documentElement.classList.remove('sf-lock');
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };
  SizeFinder.prototype.setChart = function (key) { this.chart = this.o.charts[key]; this.o.chartKey = key; this.view = null; this.render(); this.updateTrigger(); };
  SizeFinder.prototype.setLang = function (l) { this.lang = l === 'en' ? 'en' : 'ka'; this.render(); this.updateTrigger(); };
  SizeFinder.prototype.persist = function () { save(this.p); };

  /* value display */
  SizeFinder.prototype.disp = function (kind) {
    var t = this.t(), p = this.p;
    if (kind === 'h') {
      if (!p.imperial) return { v: Math.round(p.h), u: t.cm };
      var inch = Math.round(p.h / 2.54);
      return { v: Math.floor(inch / 12) + '′' + (inch % 12) + '″', u: '' };
    }
    if (!p.imperial) return { v: Math.round(p.w), u: t.kg };
    return { v: Math.round(p.w / 0.45359), u: t.lb };
  };
  SizeFinder.prototype.nudge = function (kind, dir) {
    var p = this.p;
    if (kind === 'h') p.h = clamp(Math.round((p.h + dir * (p.imperial ? 2.54 : 1)) * 10) / 10, 140, 210);
    else p.w = clamp(Math.round((p.w + dir * (p.imperial ? 0.45359 : 1)) * 100) / 100, 40, 160);
    this.refreshStep1();
  };

  SizeFinder.prototype.header = function () {
    var t = this.t(), c = this.chart, lbl = (c.label && c.label[this.lang]) || KIND_NAME[this.lang][c.kind] || '';
    var stepTxt = this.step <= 3 ? fmt(t.step, { n: this.step }) : '';
    return '<div class="sf-head">' +
      '<div class="sf-head-l"><span class="sf-eyebrow">' + esc(t.eyebrow) + (lbl ? ' · ' + esc(lbl) : '') + '</span>' +
      (stepTxt ? '<span class="sf-count">' + stepTxt + '</span>' : '') + '</div>' +
      (this.o.mode === 'inline' ? '' : '<button type="button" class="sf-x" data-act="close" aria-label="' + esc(t.close) + '">×</button>') +
      '</div><div class="sf-bar"><i style="width:' + (Math.min(this.step, 3) / 3 * 100) + '%"></i></div>';
  };

  SizeFinder.prototype.render = function () {
    var t = this.t(), p = this.p, html = this.header(), self = this;
    if (this.step === 1) {
      var hd = this.disp('h'), wd = this.disp('w');
      html += '<div class="sf-body">' +
        '<h2 class="sf-title">' + esc(t.s1Title) + '</h2><p class="sf-sub">' + esc(t.s1Sub) + '</p>' +
        '<div class="sf-seg" role="radiogroup" aria-label="sex">' +
          '<button type="button" role="radio" aria-checked="' + (p.sex === 'f') + '" data-act="sex" data-v="f">' + esc(t.female) + '</button>' +
          '<button type="button" role="radio" aria-checked="' + (p.sex === 'm') + '" data-act="sex" data-v="m">' + esc(t.male) + '</button>' +
        '</div>' +
        '<div class="sf-measure">' +
          '<div class="sf-figwrap" data-fig>' + figure(p.h, p.w, p.sex) + '</div>' +
          '<div class="sf-dials">' +
            '<div class="sf-units"><button type="button" data-act="units" data-v="0" aria-pressed="' + !p.imperial + '">' + esc(t.unitsMetric) + '</button>' +
              '<button type="button" data-act="units" data-v="1" aria-pressed="' + !!p.imperial + '">' + esc(t.unitsImperial) + '</button></div>' +
            this.dial('h', t.height, hd) + this.dial('w', t.weight, wd) +
          '</div>' +
        '</div>' +
        '<div class="sf-live"><div><span class="sf-k">' + esc(t.live) + '</span><span class="sf-live-sub">' + esc(t.liveSub) + '</span></div>' +
          '<b data-live>' + recommend(p, this.chart).best.size + '</b></div>' +
        '</div>' + this.foot(false, t.next);
    } else if (this.step === 2) {
      html += '<div class="sf-body"><h2 class="sf-title">' + esc(t.s2Title) + '</h2><p class="sf-sub">' + esc(t.s2Sub) + '</p>' +
        ['chest', 'stomach', 'hips'].map(function (k) {
          return '<fieldset class="sf-shape"><legend class="sf-k">' + esc(t[k]) + '</legend><div class="sf-shape-row">' +
            [-1, 0, 1].map(function (v) {
              return '<button type="button" class="sf-opt" data-act="shape" data-k="' + k + '" data-v="' + v + '" aria-pressed="' + (p[k] === v) + '">' +
                shapeIcon(k, v) + '<span>' + esc(t[k + 'O'][v + 1]) + '</span></button>';
            }).join('') + '</div></fieldset>';
        }).join('') + '</div>' + this.foot(true, t.next);
    } else if (this.step === 3) {
      html += '<div class="sf-body"><h2 class="sf-title">' + esc(t.s3Title) + '</h2><p class="sf-sub">' + esc(t.s3Sub) + '</p><div class="sf-fits" role="radiogroup">' +
        ['slim', 'regular', 'relaxed'].map(function (f) {
          return '<button type="button" class="sf-fit" role="radio" data-act="fit" data-v="' + f + '" aria-checked="' + (p.fit === f) + '">' +
            fitIcon(f) + '<span><b>' + esc(t.fit[f][0]) + '</b><small>' + esc(t.fit[f][1]) + '</small></span></button>';
        }).join('') + '</div></div>' + this.foot(true, t.show);
    } else {
      html += this.result();
    }
    this.dlg.innerHTML = html;
    if (this.step === 4 && this.o.onResult) this.o.onResult(recommend(p, this.chart).best.size, p);
    void self;
  };

  SizeFinder.prototype.dial = function (kind, label, dv) {
    var p = this.p, min = kind === 'h' ? 140 : 40, max = kind === 'h' ? 210 : 160;
    return '<div class="sf-dial-wrap"><span class="sf-k">' + esc(label) + '</span>' +
      '<div class="sf-dial" role="slider" tabindex="0" data-dial="' + kind + '" aria-label="' + esc(label) + '" aria-valuemin="' + min +
        '" aria-valuemax="' + max + '" aria-valuenow="' + Math.round(kind === 'h' ? p.h : p.w) + '" aria-valuetext="' + esc(dv.v + ' ' + dv.u) + '">' +
        '<button type="button" tabindex="-1" class="sf-pm" data-act="nudge" data-k="' + kind + '" data-v="-1" aria-hidden="true">−</button>' +
        '<span class="sf-num" data-drag="' + kind + '"><span data-val>' + dv.v + '</span><small data-unit>' + esc(dv.u) + '</small></span>' +
        '<button type="button" tabindex="-1" class="sf-pm" data-act="nudge" data-k="' + kind + '" data-v="1" aria-hidden="true">+</button>' +
      '</div></div>';
  };

  SizeFinder.prototype.foot = function (back, nextLabel) {
    var t = this.t();
    return '<div class="sf-foot">' +
      (back ? '<button type="button" class="sf-btn sf-btn--ghost" data-act="back">' + esc(t.back) + '</button>' : '<span></span>') +
      '<button type="button" class="sf-btn" data-act="next">' + esc(nextLabel) + '</button></div>' +
      '<p class="sf-privacy">' + esc(t.privacy) + '</p>';
  };

  SizeFinder.prototype.refreshStep1 = function () {
    var dlg = this.dlg, p = this.p, self = this;
    ['h', 'w'].forEach(function (k) {
      var dv = self.disp(k), el = dlg.querySelector('[data-dial="' + k + '"]');
      if (!el) return;
      el.querySelector('[data-val]').textContent = dv.v;
      el.querySelector('[data-unit]').textContent = dv.u;
      el.setAttribute('aria-valuenow', Math.round(k === 'h' ? p.h : p.w));
      el.setAttribute('aria-valuetext', dv.v + ' ' + dv.u);
    });
    var fig = dlg.querySelector('[data-fig]'); if (fig) fig.innerHTML = figure(p.h, p.w, p.sex);
    var live = dlg.querySelector('[data-live]');
    if (live) {
      var s = recommend(p, this.chart).best.size;
      if (live.textContent !== s) { live.textContent = s; live.classList.remove('sf-pop'); void live.offsetWidth; live.classList.add('sf-pop'); }
    }
  };

  SizeFinder.prototype.result = function () {
    var t = this.t(), p = this.p, c = this.chart, rec = recommend(p, c), self = this;
    var view = this.view != null ? rec.rows[this.view] : rec.best;
    var isBest = view.i === rec.best.i;
    function meter(label, dev, scale, names, value) {
      var pos = clamp(dev / (scale * 2), -1, 1); // -1 … 1
      var pct = 50 + pos * 42;
      var zone = Math.abs(dev) <= scale * 0.5 ? 1 : (dev < 0 ? 0 : 2);
      return '<div class="sf-meter"><div class="sf-meter-top"><span class="sf-k">' + esc(label) + '</span><span class="sf-meter-v">' + value + ' ' + esc(t.cm) +
        ' · <b>' + esc(names[zone]) + '</b></span></div>' +
        '<div class="sf-track"><span class="sf-ideal"></span><i style="left:' + pct.toFixed(1) + '%"></i></div>' +
        '<div class="sf-track-l"><span>' + esc(names[0]) + '</span><span>' + esc(names[1]) + '</span><span>' + esc(names[2]) + '</span></div></div>';
    }
    var html = '<div class="sf-body sf-result">' +
      '<div class="sf-hero">' +
        '<span class="sf-k">' + esc(isBest ? t.best : fmt(t.viewing, { s: view.size })) + '</span>' +
        '<div class="sf-ring' + (isBest ? '' : ' sf-ring--alt') + '"><svg viewBox="0 0 120 120" aria-hidden="true"><circle cx="60" cy="60" r="54" class="sf-ring-bg"/>' +
          '<circle cx="60" cy="60" r="54" class="sf-ring-fg" stroke-dasharray="' + (339.3 * view.match / 100).toFixed(1) + ' 339.3"/></svg>' +
          '<b>' + esc(view.size) + '</b></div>' +
        '<span class="sf-match">' + fmt(t.match, { n: view.match }) + '</span>' +
      '</div>' +
      '<div class="sf-sizes" role="radiogroup">' + rec.rows.map(function (r) {
        return '<button type="button" role="radio" data-act="view" data-v="' + r.i + '" aria-checked="' + (r.i === view.i) + '"' +
          (r.i === rec.best.i ? ' data-best' : '') + '>' + esc(r.size) + '</button>';
      }).join('') + '</div><p class="sf-hint">' + esc(t.tapHint) + '</p>' +
      '<div class="sf-meters">' +
        meter(t.chest, view.dev.chest, 6, t.scaleChest, c.chest[view.i]) +
        meter(t.length, view.dev.length, 4, t.scaleLen, c.length[view.i]) +
        (c.sleeve ? meter(t.sleeve, view.dev.sleeve, 4, t.scaleLen, c.sleeve[view.i]) : '') +
      '</div>' +
      '<div class="sf-note"><span class="sf-k">' + esc(t.noteLabel) + '</span><p>' + esc(noteFor(t, rec, isBest ? null : view)) + '</p></div>' +
      '<details class="sf-table"><summary>' + esc(t.table) + '</summary><div class="sf-table-scroll"><table><thead><tr><th></th>' +
        c.sizes.map(function (s, i) { return '<th' + (i === view.i ? ' class="on"' : '') + '>' + esc(s) + '</th>'; }).join('') + '</tr></thead><tbody>' +
        [['chest', t.chest], ['length', t.length], ['sleeve', t.sleeve]].filter(function (r) { return c[r[0]]; }).map(function (r) {
          return '<tr><th>' + esc(r[1]) + '</th>' + c[r[0]].map(function (v, i) { return '<td' + (i === view.i ? ' class="on"' : '') + '>' + v + '</td>'; }).join('') + '</tr>';
        }).join('') + '</tbody></table></div><p>' + esc(t.tableNote) + '</p></details>' +
      '</div>' +
      '<div class="sf-foot"><button type="button" class="sf-btn sf-btn--ghost" data-act="edit">' + esc(t.edit) + '</button>' +
        '<button type="button" class="sf-btn" data-act="choose" data-v="' + esc(view.size) + '">' + esc(fmt(t.choose, { s: view.size })) + '</button></div>' +
      '<p class="sf-privacy" data-toast>' + esc(t.privacy) + '</p>';
    void self;
    return html;
  };

  /* ---------- events ---------- */
  SizeFinder.prototype.onClick = function (e) {
    var b = e.target.closest('[data-act]'); if (!b) return;
    var a = b.getAttribute('data-act'), v = b.getAttribute('data-v'), p = this.p, t = this.t();
    if (a === 'close') return this.close();
    if (a === 'sex') { p.sex = v; this.render(); return; }
    if (a === 'units') { p.imperial = v === '1'; this.render(); return; }
    if (a === 'nudge') { if (this.dragMoved) return; this.nudge(b.getAttribute('data-k'), +v); return; }
    if (a === 'shape') { p[b.getAttribute('data-k')] = +v; this.render(); return; }
    if (a === 'fit') { p.fit = v; this.render(); return; }
    if (a === 'next') { this.step++; if (this.step === 4) { p.done = true; this.view = null; this.persist(); this.updateTrigger(); } this.render(); return; }
    if (a === 'back') { this.step--; this.render(); return; }
    if (a === 'edit') { this.step = 1; this.render(); return; }
    if (a === 'view') { this.view = +v; this.render(); return; }
    if (a === 'choose') {
      var ok = (this.o.onSelect || selectSizeOnPage)(v);
      d.dispatchEvent(new CustomEvent('size-finder:select', { detail: { size: v, applied: ok !== false } }));
      var toast = this.dlg.querySelector('[data-toast]');
      if (toast) { toast.textContent = fmt(t.chosen, { s: v }); toast.classList.add('sf-ok'); }
      var self = this;
      if (this.overlay) setTimeout(function () { self.close(); }, 650);
    }
  };

  SizeFinder.prototype.onKey = function (e) {
    var dial = e.target.closest && e.target.closest('[data-dial]');
    if (dial) {
      var k = dial.getAttribute('data-dial'), map = { ArrowUp: 1, ArrowRight: 1, ArrowDown: -1, ArrowLeft: -1, PageUp: 5, PageDown: -5 };
      if (map[e.key]) { e.preventDefault(); var n = Math.abs(map[e.key]), dir = Math.sign(map[e.key]); for (var i = 0; i < n; i++) this.nudge(k, dir); }
      return;
    }
    if (e.key === 'Tab' && this.overlay && !this.overlay.hidden) {
      var f = this.dlg.querySelectorAll('button:not([tabindex="-1"]), [tabindex="0"], summary');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  /* drag a number left/right (or up/down) to change it */
  SizeFinder.prototype.onDragStart = function (e) {
    var dial = e.target.closest('[data-dial]'); if (!dial) return;
    var self = this, k = dial.getAttribute('data-dial'), sx = e.clientX, sy = e.clientY, acc = 0;
    this.dragMoved = false;
    var STEP = 7;
    function move(ev) {
      var delta = (ev.clientX - sx) - (ev.clientY - sy);
      var units = Math.trunc((delta - acc) / STEP);
      if (units !== 0) {
        self.dragMoved = true;
        acc += units * STEP;
        var dir = Math.sign(units);
        for (var i = 0; i < Math.abs(units); i++) self.nudge(k, dir);
      }
    }
    function up() {
      w.removeEventListener('pointermove', move); w.removeEventListener('pointerup', up); w.removeEventListener('pointercancel', up);
      dial.classList.remove('sf-dragging');
      setTimeout(function () { self.dragMoved = false; }, 0);
    }
    dial.classList.add('sf-dragging');
    w.addEventListener('pointermove', move); w.addEventListener('pointerup', up); w.addEventListener('pointercancel', up);
  };

  /* ---------- auto-mount from Liquid ---------- */
  function autoMount() {
    var nodes = d.querySelectorAll('[data-size-finder]:not([data-sf-ready])');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      el.setAttribute('data-sf-ready', '');
      var src = d.getElementById(el.getAttribute('data-charts') || 'sf-charts');
      var charts; try { charts = JSON.parse(src.textContent); } catch (e) { continue; }
      var key = el.getAttribute('data-chart'), c = charts[key];
      if (!c) continue;
      if (c.table) { var parsed = parseTable(c.table); if (!parsed) { el.hidden = true; continue; } Object.assign(c, parsed); }
      charts[key] = limitSizes(c, c.sizes_on_product);
      var inst = new SizeFinder({
        charts: charts, chartKey: key, lang: siteLang(el.getAttribute('data-lang')), labelKa: el.getAttribute('data-label'),
        mode: 'modal', trigger: el.querySelector('[data-sf-open]') || el
      });
      el.sizeFinder = inst;
      (w.SizeFinderInstances = w.SizeFinderInstances || []).push(inst);
    }
  }

  w.SizeFinder = {
    create: function (o) { return new SizeFinder(o); },
    mount: autoMount,
    recommend: recommend,
    parseTable: parseTable,
    selectSizeOnPage: selectSizeOnPage,
    setLang: function (l) { (w.SizeFinderInstances || []).forEach(function (s) { s.setLang(l); }); }
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', autoMount); else autoMount();
})(window, document);